import type { CurriculumDto } from '@_/api-contracts/common.ts';

/* Expand curriculums into academic levels */
export function expandCurriculumIds(
  curricula: CurriculumDto[],
  academicLevelIds: string[],
  curriculumIds: string[]
): string[] {
  const result = academicLevelIds.slice();

  // Select all academic levels under each selected curriculum
  if (curriculumIds.length) {
    curricula.forEach(curriculum => {
      if (curriculumIds.includes(curriculum.id)) {
        curriculum.academicLevels?.forEach(level => {
          if (!result.includes(level.id)) {
            result.push(level.id);
          }
        });
      }
    });
  }

  return result;
}

/* Collapse academic levels into curriculums */
export function reduceAcademicLevelIds(
  curricula: CurriculumDto[],
  academicLevelIds: string[],
  curriculumIds?: string[]
): {
  academicLevelIds: string[];
  curriculumIds: string[];
} {
  const result = {
    academicLevelIds: academicLevelIds.slice(),
    curriculumIds: curriculumIds?.slice() || []
  };

  // Map selected academic levels to their respective curriculum
  if (academicLevelIds.length) {
    curricula.forEach(curriculum => {
      const levelIds = curriculum.academicLevels?.map(l => l.id) || [];
      if (levelIds.every(id => result.academicLevelIds.includes(id))) {
        result.academicLevelIds = result.academicLevelIds.filter(id => !levelIds.includes(id));
        if (!result.curriculumIds.includes(curriculum.id)) {
          result.curriculumIds.push(curriculum.id);
        }
      }
    });
  }

  return result;
}
